/**
 * Cartly Pro Theme JavaScript
 * Handles: mobile menu toggle, anchor link behavior, FAQ accordion
 */

/* Mobile Menu Toggle */
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const menu = document.querySelector('#mobile-menu');

  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      menu.hidden = expanded;
    });

    /* Close mobile menu when an anchor link is clicked */
    menu.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', () => {
        toggle.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
      });
    });
  }

  /* Close mobile menu when clicking outside */
  document.addEventListener('click', (e) => {
    if (toggle && menu && !menu.hidden) {
      const header = document.querySelector('[data-header]');
      if (header && !header.contains(e.target)) {
        toggle.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
      }
    }
  });

  /* Logo: scroll to top if already on the homepage */
  const logo = document.querySelector('.header__logo');
  if (logo) {
    logo.addEventListener('click', (e) => {
      if (window.location.pathname === logo.pathname) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }

  /* Pricing Slider */
  function initPricingSliders(root) {
    root.querySelectorAll('[data-pricing-slider]:not([data-initialized])').forEach((slider) => {
      slider.setAttribute('data-initialized', '');

      const tiersJson = slider.querySelector('[data-slider-tiers]');
      if (!tiersJson) return;

      let tiers;
      try { tiers = JSON.parse(tiersJson.textContent); } catch (e) { return; }
      if (!tiers.length) return;

      const track = slider.querySelector('[data-slider-track]');
      const fill = slider.querySelector('[data-slider-fill]');
      const thumb = slider.querySelector('[data-slider-thumb]');
      const priceEl = slider.querySelector('[data-slider-price]');
      const ordersEl = slider.querySelector('[data-slider-orders]');
      const card = slider.closest('.pricing__card');
      const cardAmount = card ? card.querySelector('.pricing__amount') : null;
      const cardPeriod = card ? card.querySelector('.pricing__period') : null;

      const minPct = 4;
      const maxPct = 96;
      const step = tiers.length > 1 ? (maxPct - minPct) / (tiers.length - 1) : 0;
      const stops = tiers.map((t, i) => ({ ...t, position: minPct + step * i }));

      let active = false;

      function getClosestTier(pct) {
        let closest = stops[0];
        for (const s of stops) {
          if (s.position > pct) break;
          closest = s;
        }
        return closest;
      }

      function update(pct) {
        const tier = getClosestTier(pct);
        fill.style.width = pct + '%';
        thumb.style.left = pct + '%';
        priceEl.textContent = tier.price;
        ordersEl.textContent = tier.orders;
        if (cardAmount) cardAmount.textContent = tier.price;
        if (cardPeriod) cardPeriod.textContent = '/ month';
      }

      function getPct(e) {
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        const rect = track.getBoundingClientRect();
        const raw = ((clientX - rect.left) / rect.width) * 100;
        return Math.max(minPct, Math.min(maxPct, raw));
      }

      /* Initialize with first tier */
      update(stops[0].position);

      thumb.addEventListener('mousedown', () => { active = true; });
      thumb.addEventListener('touchstart', () => { active = true; }, { passive: true });

      document.addEventListener('mouseup', () => { active = false; });
      document.addEventListener('touchend', () => { active = false; });

      document.addEventListener('mousemove', (e) => {
        if (!active) return;
        update(getPct(e));
      });
      document.addEventListener('touchmove', (e) => {
        if (!active) return;
        update(getPct(e));
      }, { passive: true });

      /* Click on track to jump */
      track.addEventListener('click', (e) => {
        update(getPct(e));
      });
    });
  }

  initPricingSliders(document);

  /* Re-initialize sliders when Shopify theme editor re-renders sections */
  document.addEventListener('shopify:section:load', (e) => {
    initPricingSliders(e.target);
  });

  /* FAQ: Only one item open at a time */
  document.querySelectorAll('[data-faq-list]').forEach((list) => {
    list.addEventListener('toggle', (e) => {
      if (e.target.open) {
        list.querySelectorAll('details[open]').forEach((d) => {
          if (d !== e.target) d.removeAttribute('open');
        });
      }
    }, true);
  });
});
